/**
* 系统管理 角色管理
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>角色管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">

			<el-form-item label="搜索：">
				<el-input size="small" v-model="formInline.roleName" placeholder="输入角色名称"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="name" label="角色">
			</el-table-column>
			<el-table-column prop="createTime" label="添加时间">
			</el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click='closeDialog("edit")'>
			<el-transfer style="width: 100%;" v-model="editForm.menus" :data="listData1"></el-transfer>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('xg')">保存
				</el-button>
			</div>
		</el-dialog>
		<!-- 编辑界面 -->
		<el-dialog title="新增角色" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
			<el-form label-width="120px" :model="editForm1" ref="editForm">
				<el-form-item label="名称" prop="systemNo">
					<el-input size="small" v-model="editForm1.name" auto-complete="off" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="roleName">
					<el-input size="small" v-model="editForm1.description" auto-complete="off" placeholder="描述">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm1('tj')">添加
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getManageUserList,
		getRoleListPage,
		addYhRole,
		assignRolePermissions,
		getAllMenu,
		yhRoleAuthArr
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				editFormVisible: false, //控制编辑页面显示与隐藏
				menuAccessshow: false, //控制数据权限显示与隐藏
				title: '添加',
				editForm: {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					roleId: '',
					menus: '',
				},
				editForm1: {
					name: '',
					desc: '',
				},
				options: [],
				listData1: [],
				formInline: {
					page: 1,
					limit: 20,
					varLable: '',
					varName: '',
				},
				listData: [], //用户数据
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 20,
					total: 10
				}
			}
		},
		// 注册组件
		components: {
			Pagination
		},


		watch: {},



		created() {
			this.getdata(this.formInline)
			this.getAllMenu()
		},

		methods: {
			// 获取角色列表
			getAllMenu() {
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
				}
				getAllMenu(pro)
					.then(res => {
						if (res.code == 0) {
							this.listData1 = res.data
						}
					})
			},
			getdata(parameter) {
				this.loading = true
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"page": parameter.page,
					"pageSize": parameter.limit,
					"name": parameter.roleName
				}
				getRoleListPage(pro)
					.then(res => {
						this.loading = false
						if (res.code == 0) {
							this.listData = res.data.list
							// 分页赋值
							this.pageparm.currentPage = res.data.pageNum
							this.pageparm.pageSize = res.data.pageSize
							this.pageparm.total = res.data.total
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.page = parm.currentPage
				this.formInline.limit = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
				this.getdata(this.formInline)
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.yhRoleAuthArr(row.id)
					this.title = row.name
					this.editForm.roleId = row.id
				}
			},
			handleEdit1: function(index, row) {
				this.menuAccessshow = true
			},
			yhRoleAuthArr(id) {
				console.log(1)
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"roleId": id
				}
				yhRoleAuthArr(pro)
					.then(res => {
						if (res.code == 0) {
							this.editForm.menus = res.data
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				let pro = {
					"userId": this.editForm.userId,
					"roleId": this.editForm.roleId,
					"menus": []
				}
				this.editForm.menus.forEach(it => {
					pro.menus.push({
						"menuId": it
					})
				})
				assignRolePermissions(pro)
					.then(res => {
						this.editFormVisible = false
						this.loading = false
						if (res.code == 1) {
							this.$message({
								type: 'info',
								message: res.message
							})
						} else {
							this.$message({
								type: 'success',
								message: '角色修改成功！'
							})
							this.getdata(this.formInline)
						}
					})

			},
			submitForm1(editData) {
				let pro = this.editForm1
				addYhRole(pro)
					.then(res => {
						this.menuAccessshow = false
						if (res.code == 1) {
							this.$message({
								type: 'info',
								message: res.message
							})
						} else {
							this.$message({
								type: 'success',
								message: '账号修改成功！'
							})
							this.getdata(this.formInline)
						}
					})

			},




			// 关闭编辑、增加弹出框
			closeDialog(dialog) {
				if (dialog == 'edit') {
					this.editFormVisible = false
				} else if (dialog == 'perm') {
					this.menuAccessshow = false
				}
			}
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/Permission.vue